function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 80.029c24.568-24.568 53.823-44.451 86.31-58.191C119.146 8.098 154.862.5 192.352.5c37.49 0 73.206 7.598 105.691 21.338 32.486 13.74 61.741 33.623 86.31 58.19"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 93.865c24.568-24.568 53.823-44.451 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.739 61.741 33.622 86.31 58.19"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 107.7c24.568-24.567 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.338 105.69-21.338 37.49 0 73.206 7.598 105.691 21.339 32.486 13.739 61.741 33.622 86.31 58.19"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 121.537c24.568-24.569 53.823-44.452 86.31-58.19 32.484-13.742 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.738 61.741 33.622 86.31 58.19"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 135.373c24.568-24.568 53.823-44.451 86.31-58.19 32.484-13.742 68.2-21.34 105.69-21.34 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 149.208c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 163.044c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 176.88c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 190.716c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 204.552c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 218.388c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.34 32.486 13.738 61.741 33.621 86.31 58.19"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 232.224c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.339 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 246.06c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.339 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 259.896c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 273.732c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 287.568c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 301.404c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 315.24c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.34 105.69-21.34 37.49 0 73.206 7.599 105.691 21.34 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 329.076c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.338 105.69-21.338 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 342.911c24.568-24.567 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.337 105.69-21.337 37.49 0 73.206 7.596 105.691 21.337 32.486 13.74 61.741 33.623 86.31 58.19"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 356.748c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.741 68.2-21.339 105.69-21.339 37.49 0 73.206 7.598 105.691 21.339 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 370.583c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.338 105.69-21.338 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 384.42c24.568-24.569 53.823-44.45 86.31-58.19 32.484-13.742 68.2-21.339 105.69-21.339 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 398.255c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.338 105.69-21.338 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 412.091c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.338 105.69-21.338 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.353 425.927c24.568-24.568 53.823-44.45 86.31-58.19 32.484-13.74 68.2-21.338 105.69-21.338 37.49 0 73.206 7.597 105.691 21.338 32.486 13.74 61.741 33.622 86.31 58.19"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 385 427"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/parallel-lines-3.aaaf4c16.svg";
export { SvgComponent as ReactComponent };